export default __webpack_public_path__ + "static/media/Deed of Contract_09.0e732264.jpg";